<template>
    <div class="schoolDetailHome">
        <div class="sd1">
            <img :src="'https://public.rossoarts.com/static/uploads/' + schoolData.school_img" alt="" class="sd1_bgc">
            <div class="sd1_cont">
                <img class="sd1_logo" :src="' https://public.rossoarts.com/static/uploads/' + schoolDataLogo" alt="">
                <p class="cn">{{ schoolData.cname }}</p>
                <p class="en">{{ schoolData.ename }}</p>
                <p class="p4"><span>国家：{{ schoolData.country }}</span><span>学制：本科、研究生</span></p>
                <p class="p3">优势专业：{{ schoolData.major }}</p>
                <div class="sd1_btn_box">

                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="kefubtn">
                        <div><img src="../img/Group 595.png" alt="">立即咨询</div>
                    </a>
                    <a href="javascript:void(0)" @click="coverInp()" class="kefubtn">
                        <div><img src="../img/Group 596.png" alt="">领取攻略</div>
                    </a>
                </div>

            </div>

        </div>
        <div class="sd2">
            <div class="sd2_cont">
                <div class="sd2_item">
                    <div class="sd2_item_top">
                        <span></span>
                        <p>申请截止</p>
                        <span></span>
                    </div>
                    <div class="sd2_item_bottom">
                        {{ schoolData.off_date | offDate }}
                    </div>
                </div>
                <div class="sd2_item">
                    <div class="sd2_item_top">
                        <span></span>
                        <p>申请难度</p>
                        <span></span>
                    </div>
                    <div class="sd2_item_bottom">
                        困难
                    </div>
                </div>
                <div class="sd2_item">
                    <div class="sd2_item_top">
                        <span></span>
                        <p>语言要求</p>
                        <span></span>
                    </div>
                    <div class="sd2_item_bottom">

                        <p class="p2">雅思 {{ schoolData.ielts }}</p>
                        <p class="p2">托福 {{ schoolData.toefl }}</p>
                        <p class="p2">SAT {{ schoolData.sat }}</p>
                    </div>
                </div>
                <div class="sd2_item">
                    <div class="sd2_item_top">
                        <span></span>
                        <p>院校性质</p>
                        <span></span>
                    </div>
                    <div class="sd2_item_bottom">
                        {{ schoolData.nature }}
                    </div>
                </div>
                <div class="sd2_item">
                    <div class="sd2_item_top">
                        <span></span>
                        <p>院校地址</p>
                        <span></span>
                    </div>
                    <div class="sd2_item_bottom">
                        {{ schoolData.address }}
                    </div>
                </div>
            </div>
        </div>

        <div class="sd4">

            <div class="sd4_left">
                <img style=" width: 100%;
        height: 100%;" :src="' https://public.rossoarts.com/static/uploads/' + schoolData.school_img_small" alt="">
                <div class="sd4_left_ben">
                    <div class="sd4_left_xuezhi">
                        <div class="sd4_left_xuezhi_title">按学制筛选</div>
                        <div class="sd4_left_xuezhi_item" @click="toggleBen(0)" style="background-color: #FB6333;">
                            <img src="../img/Group 597.png" alt="">
                            <p>本科生</p>
                        </div>
                        <div class="sd4_left_xuezhi_item" @click="toggleBen(1)">
                            <img src="../img/Group 599.png" alt="">
                            <p>研究生</p>
                        </div>
                    </div>
                    <div class="sd4_left_major">
                        <div class="sd4_left_xuezhi_title">按专业筛选</div>
                        <el-select v-model="onemajor" placeholder="请选择" @change="changeOption">
                            <el-option v-for="(item, index) in options" :label="item.major_cname" :key="index" :value="item.major_introduction">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="sd4_right">
                <div class="sd4_right_top">
                    <div class="sd4_right_top_item" @click="toggleSd4top(0)">简介</div>
                    <div class="sd4_right_top_item" @click="toggleSd4top(1)">院校专业</div>
                    <div class="sd4_right_top_item" @click="toggleSd4top(2)">申请要求</div>
                    <div class="sd4_right_top_item" @click="toggleSd4top(3)">学生案例</div>
                    <div class="sd4_right_top_item" @click="toggleSd4top(4)">导师推荐</div>
                </div>
                <div class="sd4_right_cont" style="display: block; width: 764px;
            
            box-sizing: border-box;">
                    {{ schoolData.college_profiles }}
                </div>
                <div class="sd4_right_cont" style="display: none; width: 764px;
            
            box-sizing: border-box;" id="theContid4">
                    {{ cont }}
                    
                </div>
                <div class="sd4_right_cont" style="display: none; width: 764px;
           
            box-sizing: border-box;">
                    <div class="sd3_major">
                        <div class="sd3_major_title"> · 截止日期 （Deadline）</div>
                        <div>{{ schoolData.off_date }}</div>
                    </div>
                    <div class="sd3_major">
                        <div class="sd3_major_title"> · 申请要求 （Application Requirements）</div>
                        <div >{{ theappReq }}</div>
                        <!-- style="white-space: pre-wrap;" -->
                    </div>
                    <div class="sd3_major">
                        <div class="sd3_major_title"> · 申请方式 （How to apply）</div>
                        <div>{{ theappWay }}</div>
                    </div>
                    <div class="sd3_major">
                        <div class="sd3_major_title"> · 申请步骤 （Application Steps）</div>
                        <div>{{ theappStep }}</div>
                    </div>
                </div>
                <div class="sd4_right_cont sd4_cont4" style="">
                    <div class="swiper mySwiper2">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in selectedData" :key="index">
                                <div class="s34item" v-for="(item2, index2) in item" :key="index2" @click="caseDetail(item2.id)">

                                    <img :src="'https://public.rossoarts.com/static/uploads/case/' + item2.portfolioShow"
                                        alt="">
                                    <div class="s34_top">
                                        <p class="s34_p2">{{ item2.name }}</p>
                                        <p class="s34_p1">RoSSo</p>
                                    </div>
                                    <div class="s34_bot">
                                        <p>录取专业：{{ item2.cname }}</p>
                                        <p>录取院校：{{ item2.school | schoolSplit }}</p>
                                    </div>

                                    <!-- <p class="s34_p3">{{ item2.cname }}</p>
                                        <p class="s34_p3"></p> -->
                                </div>
                               <div v-if="item.length<4" v-for="(item3,index3) in 4-item.length" :key="index3" class="s34item"></div>
                                <!-- <div v-if="(!((selectLength)/4) && ((Math.ceil(selectLength/4)) == index))" class="s34item"></div>
                                <div v-if="(!((selectLength+1)/4) && ((Math.ceil(selectLength/4)) == index))" class="s34item"></div>
                                <div v-if="(!((selectLength+2)/4) && ((Math.ceil(selectLength/4)) == index))" class="s34item"></div>
                                <div v-if="(!((selectLength+3)/4) && ((Math.ceil(selectLength/4)) == index))" class="s34item"></div> -->
                                
                            </div>
                        </div>
                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-pagination"></div>
                    </div>

                </div>
                <div class="sd4_right_cont t4_cont" style="">

                    <div class="swiper mySwiperT2">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in tutors1Data">

                                <div class="t4_item" v-for="(item2, index2) in item" @click="tutorsDetail(item2.id)">
                                    <div class="t4_wbox">
                                        <img :src="' https://public.rossoarts.com/static/uploads/teacher/' + item2.avatar"
                                            alt="">
                                    </div>

                                    <div class="en div1">{{ item2.school | schoolAd }}</div>
                                    <p class="t4_p1 en">{{ item2.name }}</p>
                                    <p class="t4_p2 cn">{{ item2.major }}</p>
                                    <p class="t4_p3 cn">{{ item2.school | schoolAll }}</p>

                                </div>

                            </div>

                        </div>
                        <div class="swiper-pagination"></div>
                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                    </div>

                </div>
            </div>
        </div>

        <div class="section_inp school4">
            <div class="s_inp_left">
                <img src="../img/shouchahua.png" alt="" class="img_shou animated wow rotateInDownLeft" id="imgShou">
                <img src="../img/Group 2403.png" style="width: 252px;" alt="" class="img_text animated wow rollIn"
                    id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="150px" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>


                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="选择意向国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>

                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="请输入电话号码"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="留学预算：">
                        <el-input v-model="formLabelAlign.budget" placeholder="请输入您的预算"></el-input>
                    </el-form-item> -->
                    <el-form-item class="yuyue_box">
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- <div class="slogo">
            <a class="slogo_cont" href="/schools/2.html?cname=中央圣马丁艺术与设计学院">
                <img src="../img/slogo1.png" alt="">
                <div>
                    <p>中央圣马丁艺术与设计学院</p>
                    <p>CentralSaintMartinsCollegeofArtandDesign</p>
                </div>
            </a>
        </div> -->


    </div>
</template>
<script>
import "@/assets/css/schoolsdetail.css"
import axios from "axios"
import Swiper from 'swiper/bundle'
import 'swiper/css';
import "swiper/css/effect-flip";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
export default {
    data() {
        return {
            schoolData: [],
            benMajor: [],
            theMajor: [],
            appDate: [],
            appReq: [],
            appWay: [],
            appStep: [],
            theappDate: [],
            theappReq: [],
            theappWay: [],
            theappStep: [],
            options: [],
            selectedData: [],
            selectLength:0,
            selectedArr: [],
            tutors1Data: [],
            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                budget: '',
            },
            theWebCname: "",
            value: '',
            cont: "",
            onemajor: '',
            schoolDataLogo:"",
        }
    },
    filters: {
        offDate(val){
            return val?val:"-"
        },
        schoolSplit(val) {
            // const valLength = val.split("/").length
            // return valLength<2?val.split("/")[0]:val.split("/")[0] +"/" + val.split("/")[1]
            return val.split("/")[0]
        },
        schoolAll(val) {
            return val.split(",")[0]
        },
        schoolAd(val) {
            // console.log(val,"teacher val");
            return val.split(",")[1]
        },
    },
    created() {
        this.theWebCname = this.$route.query.cname
        // console.log(this.$route.params,this.$route.query.cname);
        this.getSchoolId(this.$route.params.id.split(".")[0])
        this.getSelected()
        this.getTutors1()
      
    },
    methods: {
        caseDetail(val) {
            this.$router.push(`/case/${val}.html`)
        },
        tutorsDetail(val) {
            this.$router.push(`/teachers/${val}.html`)
        },
        // scrollForm() {
        //     var section_inp = document.getElementsByClassName("section_inp")
        //     section_inp[0].scrollIntoView({
        //         block: 'end',
        //         behavior: 'smooth',

        //     })
        // },
        coverInp() {
            var coverBlack2 = document.getElementById("coverBlack2")
            coverBlack2.style.display = "block"

        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            // console.log('submit!',this.formInline);
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "budget": this.formLabelAlign.budget,
                        "url": window.location.href,
                        "status": status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        swiperT2() {
            var swiper = new Swiper(".mySwiperT2", {
                observer: true,
                loop: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        getTutors1() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstTeacher?category=1&limit=9").then((data) => {
                // console.log(data.data);
                // console.log(this.arrGroup(data.data, 12));
                this.tutors1Data = this.arrGroup(data.data, 3)
                this.$nextTick(() => {
                    this.swiperT2()
                })
            })
        },
        getSelected() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstCase?limit=400&page=1").then((data) => {
                // console.log(data.data,"zzzz");
                // console.log(this.arrGroup(data.data, 6));
                data.data.forEach((item, index, arr) => {
                    // console.log( item.school.split("/").indexOf('帕森斯设计学院'));
                    if (item.school.split("/").indexOf(this.theWebCname) == "0") {
                        // console.log(item,index);
                        this.selectedArr.push(item)
                        
                    }
                })
                this.selectLength = this.selectedArr.length
                console.log(!((this.selectLength+3)/4) && ((Math.ceil(this.selectLength/4)) == 8));
                this.selectedData = this.arrGroup(this.selectedArr, 4)
                this.$nextTick(() => {
                    this.mySwiper2Init()
                })
            })
        },
        mySwiper2Init() {
            new Swiper(".mySwiper2", {
                observer: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                // autoplay: {
                //     delay: 3000,
                //     disableOnInteraction: false,
                // },
            })
        },
        changeOption(val) {
            // console.log(val);
            this.cont = val
        },
        toggleBen(val) {
            var sd4_left_xuezhi_item = document.getElementsByClassName("sd4_left_xuezhi_item")
            // console.log(val);
            for (var i = 0; i < sd4_left_xuezhi_item.length; i++) {
                sd4_left_xuezhi_item[i].style.backgroundColor = "#fff"
            }
            sd4_left_xuezhi_item[val].style.backgroundColor = "#FB6333"
            this.value = ""
            if (val == 0) {
                if (this.schoolData.hasOwnProperty("bk")) {

                    this.options = this.schoolData.bk
                    this.cont = Object.values(this.options)[0].major_introduction
                    this.onemajor = Object.values(this.options)[0].major_cname
                }
            } else {
                if (this.schoolData.hasOwnProperty("yjs")) {
                    this.options = this.schoolData.yjs
                    this.cont = Object.values(this.options)[0].major_introduction
                    this.onemajor = Object.values(this.options)[0].major_cname
                }
            }


        },
        toggleSd4top(val) {
            var sd4_right_top_item = document.getElementsByClassName("sd4_right_top_item")
            var sd4_left_ben = document.getElementsByClassName("sd4_left_ben")
            var sd4_right_cont = document.getElementsByClassName("sd4_right_cont")
            for (var i = 0; i < sd4_right_top_item.length; i++) {
                sd4_right_top_item[i].style.borderBottom = "4px solid transparent"
                sd4_right_cont[i].style.display = "none"
                sd4_right_top_item[i].style.fontWeight = "400"
            }
            sd4_right_top_item[val].style.borderBottom = "4px solid #000"
            sd4_right_top_item[val].style.fontWeight = "bold"
            sd4_right_cont[val].style.display = "block"
            if (val == 1) {
                sd4_left_ben[0].style.display = 'block'
            } else {
                sd4_left_ben[0].style.display = 'none'
            }
        },

        getSchoolId(val) {
            axios.get(`https://public.rossoarts.com/api/v1/getSchoolContent?id=${val}`).then((data) => {
                // console.log(data.data.data,"0921");
                // slogo_cont

                if (data.data.data.id == 4) {
                    theContid4.innerHTML = `
                    <div class="slogo">
                       <a class="slogo_cont" href="/schools/2.html?cname=中央圣马丁艺术与设计学院">
                           <img src="${require('../img/slogo1.png')}" alt="">
                           <div>
                                 <p>中央圣马丁艺术与设计学院</p>
                                <p>Central SaintMartins Collegeof Art and Design</p>
                            </div>
                       </a>
                       <a class="slogo_cont" href="/schools/34.html?cname=伦敦传媒学院">
                           <img src="${require('../img/slogo2.jpg')}" alt="">
                           <div>
                                 <p>伦敦传媒学院</p>
                                <p>London College of Communication</p>
                            </div>
                       </a>
                       <a class="slogo_cont" href="/schools/14.html?cname=伦敦时装学院">
                           <img src="${require('../img/slogo3.jpg')}" alt="">
                           <div>
                                 <p>伦敦时装学院</p>
                                <p>London College of Fashion</p>
                            </div>
                       </a>
                       <a class="slogo_cont" href="/schools/15.html?cname=坎伯韦尔艺术学院">
                           <img src="${require('../img/slogo4.jpg')}" alt="">
                           <div>
                                 <p>坎伯韦尔艺术学院</p>
                                <p>Camberwell College of Arts</p>
                            </div>
                       </a>
                       <a class="slogo_cont" href="/schools/21.html?cname=切尔西艺术学院">
                           <img src="${require('../img/slogo5.jpg')}" alt="">
                           <div>
                                 <p>切尔西艺术学院</p>
                                <p>Chelsea College of Art and Design</p>
                            </div>
                       </a>
                       <a class="slogo_cont" href="/schools/80.html?cname=温布尔登艺术学院">
                           <img src="${require('../img/slogo6.jpg')}" alt="">
                           <div>
                                 <p>温布尔登艺术学院</p>
                                <p>Wimbledon College of Art</p>
                            </div>
                       </a>

                    </div>
                    
                    `

                } else {
                    // console.log(data.data.data.hasOwnProperty("bk"));
                    if (data.data.data.hasOwnProperty("bk")) {
                        // console.log(data.data.data.bk);
                        this.cont = Object.values(data.data.data.bk)[0].major_introduction
                        // this.cont = data.data.data.bk[0].major_introduction
                    } else {
                        this.cont = ""
                    }
                }
                this.$nextTick(() => {
                    this.schoolData = data.data.data
                    this.schoolDataLogo = data.data.data.logo
                    // console.log(this.schoolData.logo, "0907");
                    var sd3_major = document.getElementsByClassName("sd3_major")
                    if (data.data.data.hasOwnProperty("bk") == true) {
                        this.options = this.schoolData.bk || []
                        this.onemajor = Object.values(this.options)[0].major_cname
                        // console.log(this.opt ions);
                        this.benMajor.push(this.schoolData.bk)
                        this.benMajor.push(this.schoolData.yjs)
                        // console.log(this.benMajor[0][0].major_cname,"bk,yjs");
                        this.theMajor = this.benMajor[0]
                        // this.value = this.benMajor[0][0].major_cname
                    }
                    this.appDate.push(this.schoolData.bk_deadline)
                    this.appDate.push(this.schoolData.yjs_deadline)
                    this.theappDate = this.appDate[0]

                    this.appReq.push(this.schoolData.bk_application_requirements)
                    this.appReq.push(this.schoolData.yjs_application_requirements)
                    this.theappReq = this.appReq[0]
                    if (this.theappStep == "") {
                        // console.log("kong 0904");
                        sd3_major[3].style.display = "none"
                    } else {
                        sd3_major[3].style.display = "block"
                    }
                    if (this.theappWay == "") {
                        // console.log("kong 0904");
                        sd3_major[2].style.display = "none"
                    } else {
                        sd3_major[2].style.display = "block"
                    }
                    if (this.theappReq == "") {
                       
                        sd3_major[1].style.display = "none"
                    } else {
                        // console.log("kong 0904",this.theappReq);
                        sd3_major[1].style.display = "block"
                    }

                    this.appWay.push(this.schoolData.bk_apply_way)
                    this.appWay.push(this.schoolData.yjs_apply_way)
                    this.theappWay = this.appWay[0]

                    this.appStep.push(this.schoolData.bk_application_steps)
                    this.appStep.push(this.schoolData.yjs_application_steps)
                    this.theappStep = this.appStep[0]
                })
            })
        },

        toggleMajor(val) {

            var sd3_cont_left_item = document.getElementsByClassName("sd3_cont_left_item")
            var sd3_major_cont_title = document.getElementsByClassName("sd3_major_cont_title")
            // console.log(this.benMajor[0].length,"this.benMajor[0].length",val);
            if (val > sd3_cont_left_item.length) {
                val = val - this.benMajor[0].length

            }

            for (var i = 0; i < sd3_cont_left_item.length; i++) {
                sd3_cont_left_item[i].style.color = "#000"
                sd3_cont_left_item[i].style.backgroundColor = "#f1f1f1"

                sd3_major_cont_title[i].style.color = "#000"
                // sd3_major_cont_title[i].style.backgroundColor = "#f1f1f1"


            }
            sd3_cont_left_item[val].style.color = "#fff"
            sd3_cont_left_item[val].style.backgroundColor = "#2ba6e1"
            sd3_major_cont_title[val].style.color = "#2ba6e1"

            // console.log(sd3_major_cont_title[val].offsetTop, "offsetTop");
            window.scrollTo(0, sd3_major_cont_title[val].offsetTop - 200)

        },
        windowScroll() {
            var sd4_right = document.getElementsByClassName("sd4_right")
            var os = sd4_right[0].offsetTop
            var st = document.documentElement.scrollTop;
            // console.log(os,st);
            if (st > os - 250) {
                // console.log("进");
                sd4_right[0].style.marginTop = 0
            } else {
                // sd4_right[0].style.marginTop = "110px";
            }

        },
        sd4rate(){
            // var sd4_right = document.getElementsByClassName("sd4_right");
            // var w = window.innerWidth;
            // sd4_right[0].style.transform = `scale(${w/1440})`
            // console.log()

            
        },

    },
    mounted() {
        this.sd4rate()
        window.addEventListener("scroll", this.windowScroll, true);
        var sd1_logo = document.getElementsByClassName("sd1_logo")
        setTimeout(()=>{
            sd1_logo[0].style.transform = "translateY(-1px)"
            // console.log(sd1_logo[0]);
        },1000)
    },
    destroyed() {
        window.removeEventListener("scroll", this.windowScroll, true);
    },
}
</script>
<style lang="less">
.slogo {
    .slogo_cont {
        // border: 1px solid #000;
        height: 80px;
        display: flex;
        align-items: center;
        color: #000;
        margin-bottom: 32px;

        img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
        }

        div {
            margin-left: 20px;

            p {
                text-decoration: underline;
                font-size: 20px;

            }
        }
    }

    .slogo_cont:hover {
        color: #fb6333;
        font-weight: bold;
    }
}
</style>